<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Result Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading class="mb-3">
      <span v-if="analyte_result" class="float-left mr-2">
        Results:
        <span v-if="analyte_result.sample">
          {{ analyte_result.sample.pid }}
        </span>
      </span>

      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['read analyte result']">
      <template #gated-content>
        <StatusProgress
          :current_status="current_status"
          :log_collection="analyte_result_status_log"
          status_group="analyte_result"
          class="mb-3"
        />

        <ResultManagerCard :analyte_result="analyte_result" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/result-manager/${analyte_result_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>

        <AuditChangeLogTable
          :model="analyte_result"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="analyte_result"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import AnalyteResultModel from '@/models/lab/AnalyteResultModel'
import ResultManagerCard from '@/components/lab/resultmanager/ResultManagerCard'
import StatusProgress from '@/components/shared/StatusProgress'
import AnalyteResultStatusLogCollection from '@/collections/lab/AnalyteResultStatusLogCollection'

export default {
  name: 'ResultManagerDetail',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    AuditChangeLogTable,
    AuditRelationTable,
    ResultManagerCard,
    StatusProgress
  },
  data () {
    return {
      loading: false,
      analyte_result_id: this.$route.params.analyte_result_id || null,
      analyte_result: null,
      analyte_result_status_log: new AnalyteResultStatusLogCollection()
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-pencil",
            linkto: `/result-manager/${this.analyte_result_id}/edit`,
            title: "Edit analyte result",
            variant: "warning",
          },
        ]
      }
    },
    current_status() {
      return (
        this.analyte_result &&
        this.analyte_result.current_analyte_result_status_log.analyte_result_status.status
      );
    },
  },
  async mounted () {
    this.loading = true

    this.analyte_result = new AnalyteResultModel({ id: this.analyte_result_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    await this.analyte_result.fetch({ params })

    this.analyte_result_status_log = this.analyte_result.getAnalyteResultStatusLogs()

    this.loading = false
  }
}
</script>
